import { v4 as uuidv4 } from 'uuid';

export const iniplayerList1 = [
    '1 Rashel Mahmud (GK)',
    '2 MD R Hasan',
    '3 Topu Berman',
    '4 Razul Karim Sr.',
    '5 Yeasin Khan',
    '6 Jamal Bhuyan Sr.',
    '9 N N Ziban Sr.',
    '16 Masuk Miah Zoni',
    '11 Sohel Rana',
    '14 A R Fahad',
    '8 S A Shahed',
    '18 Anisur Rahman (GK)',
    '20 MD Razib (GK)',
    '7 Rubel Miya',
    '10 H V Biswas',
    '12 Shakil Ahmad',
    '13 Fazlay Rabbi',
    '15 A S Yosuf Sifat',
    '17 Jewal Rana',
    '19 Aminur R Sojib',
    'Coach- G S Moreno'
]
export const iniplayerList2 = [
    '36 Abhishek Chatterjee',
    '37 Ashutosh Verma',
    '38 Bharat Batham',
    '39 Jagat Sharma',
    '40 Narendra Mahawar',
    '41 Rohit Jadhav',
    '42 Sunder Verma',
    '43 Akash Dongre',
    '44 Anish Joshi',
    '45 Narsimha Chavhan',
    '46 Prithviraj Phadnis',
    '47 Sagar Sawant',
    '49 Vinayak Auti',
    '50 B Tulshidas Sharma',
    '51 Ch Meiraba Meitei',
    '52 K Roopakanta Sharma',
    '53 Rajeev Gopinathan',
    '54 M Chandrashekhar',
    '55 Peter Rose',
    '56 V B Hadap',
    'Coach-Muttu Panigrahi',
]


export const iniTwoLiner = [
    { id: uuidv4(), name: '1 Rashel Mahmud (GK)', designation: 'Engineering Assistant, DDK Mumbai 1' },
    { id: uuidv4(), name: '2 MD R Hasan', designation: 'AAssistant Engineer, DDK Hyderabad' },
    { id: uuidv4(), name: '3 Topu Berman', designation: 'Program Producer, DDK Kolkata' },
    { id: uuidv4(), name: '4 Razul Karim Sr.', designation: 'Engineering Assistant, DDK Mumbai 4' },
    { id: uuidv4(), name: '5 Yeasin Khan', designation: 'Engineering Assistant, DDK Mumbai 5' },
    { id: uuidv4(), name: '6 Jamal Bhuyan Sr.', designation: 'Engineering Assistant, DDK Mumbai 6' },
    { id: uuidv4(), name: '9 N N Ziban Sr.', designation: 'Engineering Assistant, DDK Mumbai 7' },
    { id: uuidv4(), name: '16 Masuk Miah Zoni', designation: 'Engineering Assistant, DDK Mumbai 8' },
    { id: uuidv4(), name: '11 Sohel Rana', designation: 'Engineering Assistant, DDK Mumbai 9' },
    { id: uuidv4(), name: '14 A R Fahad', designation: 'Engineering Assistant, DDK Mumbai 10' },
    { id: uuidv4(), name: '8 S A Shahed', designation: 'Engineering Assistant, DDK Mumbai 11' },
    { id: uuidv4(), name: '18 Anisur Rahman (GK)', designation: 'Engineering Assistant, DDK Mumbai 12' },
    { id: uuidv4(), name: '20 MD Razib (GK)', designation: 'Engineering Assistant, DDK Mumbai 13' },
    { id: uuidv4(), name: '7 Rubel Miya', designation: 'Engineering Assistant, DDK Mumbai 14' },
    { id: uuidv4(), name: '10 H V Biswas', designation: 'Engineering Assistant, DDK Mumbai 15' },
    { id: uuidv4(), name: '12 Shakil Ahmad', designation: 'Engineering Assistant, DDK Mumbai 16' },
    { id: uuidv4(), name: '13 Fazlay Rabbi', designation: 'Engineering Assistant, DDK Mumbai 17' }

]

export const iniBreakingNews = [
    { id: uuidv4(), data1: 'मुख्यमंत्री योगी आदित्यनाथ ने दी मुलायम सिंह को जन्मदिन की बधाई, जानिए क्या कहा', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'दिल्ली में प्रदूषण के चलते कंस्ट्रक्शन एक्टिविटी पर लगा प्रतिबंध हटाया गया - NDTV India', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'चलने नहीं देंगे रामायण एक्सप्रेस, संतों की वेशभूषा में वेटरों पर साधुओं की चेतावनी', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'मंत्रिमंडल विस्तार से क्या ख़त्म हो जाएगी अशोक गहलोत और सचिन पायलट गुट की कलह?', use1: false, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'Shaurya Chakra: शादी के 10 महीने में हुए शहीद, I LOVE YOU कहकर पत्नी ने दी थी अंतिम विदाई', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'पाक को खदेड़ने वाले वीर का हुआ अभिनंदन, मेजर विभूति और सूबेदार सोमबीर को शौर्य चक्र', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'Lucknow Kisan Mahapanchayat: कृषि कानूनों की वापसी 70 साल में किसान आंदोलनों की सबसे बड़ी जीत', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'Pollution: दिल्ली में ट्रकों की एंट्री पर बैन जारी, वर्क फ्रॉम होम 26 नवंबर तक बढ़ा - Aaj Tak', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'पठानकोट में आर्मी कैंप के गेट के पास ग्रेनेड धमाका, सभी चौकियां हाई अलर्ट पर - NDTV India', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'तानाशाहों के लिए ना गाएं, मारे गए पत्रकार खशोगी की मंगेतर की सिंगर से अपील - आज तक', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'El Salvador President Nayib Bukele Said We Will Build World First Bitcoin City Power', use1: false, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'अमेरिका में डॉलर की बारिश: चलते ट्रक से सड़क पर नोटों से भरे कई बैग उड़े, हाईवे पर कारें खड़ी कर लूटने लगे लोग', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'ताइवान के आसमान पर चीन ने उड़ाए परणामु बम गिराने वाले विमान, बढ़ा तनाव - Hindustan हिंदी', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'Airtel Prepaid Recharge : एयरटेल ने महंगा कर दिया प्रीपेड रिचार्ज, जानें अब कितने का हुआ कौन सा प्लान', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'Paytm के शेयरों में तबाही जारी, आज फिर 15% टूटे शेयर, दो दिनों में विजय शर्मा की वेल्थ 78.10 करोड़', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'Share Market Today : सेंसेक्स हुआ धड़ाम, 1100 से ज्यादा अंकों की गिरावट, Nifty भी लुढ़का', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'पेट्रोल-डीजल हो सकता है और भी सस्ता! कीमतों में कटौती की उम्मीद - Hindustan हिंदी', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'Bigg Boss 15, 22 Nov Written Updates: प्रतीक-करण के बीच हुई धक्का-मुक्की', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'Malaika Arora जालीदार ड्रेस पहनने की वजह से हुईं ट्रोल, लोग बोले ‘सबकुछ दिख जाए, ऐसा भी क्या फैशन', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'मुझे मुंबई आने में डर लगता है, परमबीर सिंह की दलील पर SC ने दिया ये आदेश - आज तक', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
    { id: uuidv4(), data1: 'अनुपमा सीरियल में Rupali Ganguly की मां का किरदार निभा चुकीं एक्ट्रेस Madhavi Gogate का निधन', use1: true, delemeterLogo: `${window.location.origin}/ReactCasparClient/doordarshan-logo.png` },
]